import { IAuthContext, IPanel, IPanelsProvider } from 'smarthub-common'
import { panels } from 'config'

export class LocalPanelsProvider implements IPanelsProvider {
  public async process(auth: IAuthContext): Promise<IPanel[]> {
    return Promise.resolve(panels)
  }
}
